import { styled, Box, Tab } from '@ltvco/refresh-lib/theme';

export const StyledBox: React.ComponentType<React.ComponentProps<typeof Box>> =
  styled(Box)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.divider}`,
  }));

export const StyledTab: React.ComponentType<React.ComponentProps<typeof Tab>> =
  styled(Tab)(({ theme }) => ({
    color: theme.palette.text.secondary,
    borderBottom: 'none',
    fontSize: '.875rem',
    fontWeight: 'bold',

    // Accessing the custom attributes
    '&[data-active-tab="true"]': {
      color: theme.palette.text.primary,
      borderBottom: `1px solid ${theme.palette.primary.dark}`,
      fontSize: '.875rem',
      fontWeight: 'bold',
    },
  }));
